export * from './ip-contracts.model';
export * from './ip-contracts.module';
